/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { DateRangePicker } from "react-date-range";
import { format, isSameDay, getMonth } from "date-fns";
import cx from "classnames";

import {
  getGamesDateRange,
  getGamesDates,
  getUpcomingGames,
} from "../../../../features/cms/cmsSlice";
import { defaultInputRanges, defaultStaticRanges } from "./defaultRanges";

import "./styles.scss";
import styles from "./DateRange.module.scss";
import sharedStyles from "../../SharedStyles.module.scss";
import { GameItemSm } from "../GameItemSm/GameItemSm";
import Loader from "../Loader";
import { GameItemList } from "../GameItemList/GameItemList";

export const DateRange = ({ isUpcoming }) => {
  const [dateRange, setDateRange] = useState({ start: "", end: "" });
  const [loading, setLoading] = useState(true);

  const gamesDates = useSelector(getGamesDates);

  const upcomingGames = useSelector(getUpcomingGames);

  const [gamesList, setGamesList] = useState();

  const gamesDateRange = useSelector(getGamesDateRange(dateRange));
  //TODO: remove the date frfom currentMonth after March 2023
  const [currentMonth, setCurrentMonth] = useState(
    getMonth(
      new Date("March 01 2025 23:59:59 GMT-0400 (Eastern Daylight Time)")
    )
    // getMonth(new Date())
  );

  const [calState, setCalState] = useState([
    {
      startDate: null,
      endDate: new Date(""),
      key: "selection",
    },
  ]);

  function customDayContent(calDate) {
    const hasGame = gamesDates?.some(
      (gameDate) =>
        isSameDay(new Date(gameDate), new Date(calDate)) &&
        currentMonth === getMonth(calDate)
    );

    return (
      <div className={hasGame ? styles.hasGame : ""}>
        {<div className={styles.dot} />}
        <span>{format(calDate, "d")}</span>
      </div>
    );
  }
  function onShownDateChange(calDate) {
    setCurrentMonth(getMonth(calDate));
  }
  const handleSelect = ({ selection }) => {
    setDateRange({ start: selection.startDate, end: selection.endDate });
    setCalState([selection]);
  };
  const loaderOff = () => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };
  const setGamesListHandler = (gameList) => {
    setGamesList(gameList);
  };
  useEffect(() => {
    if (isUpcoming) return;
    if (
      dateRange.start &&
      dateRange.end &&
      JSON.stringify(gamesList) !== JSON.stringify(gamesDateRange)
    ) {
      setLoading(true);
      setTimeout(() => {
        setGamesListHandler(gamesDateRange);
      }, 400);
      loaderOff();
    }
  }, [gamesDateRange]);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      if (isUpcoming) {
        setGamesListHandler(upcomingGames);
      } else {
        setGamesListHandler([]);
      }
    }, 400);
    loaderOff();
  }, [isUpcoming]);

  return (
    <div
      className={cx(styles.dateRange, {
        [styles.isUpcoming]: isUpcoming,
      })}
    >
      <div
        className={cx(styles.dateRangeWrapper, {
          [styles.isUpcoming]: isUpcoming,
        })}
      >
        <DateRangePicker
          editableDateInputs={true}
          onChange={handleSelect}
          rangeColors={["#000847"]}
          showSelectionPreview={true}
          moveRangeOnFirstSelection={false}
          months={1}
          minDate={new Date()}
          maxDate={
            new Date("Dec 31 2025 23:59:59 GMT-0400 (Eastern Daylight Time)")
          }
          ranges={calState}
          dayContentRenderer={customDayContent}
          onShownDateChange={onShownDateChange}
          direction="horizontal"
          staticRanges={defaultStaticRanges}
          inputRanges={defaultInputRanges}
          startDatePlaceholder="--"
          endDatePlaceholder="--"
          //   //TODO: remove the date frfom currentMonth after March 2023
          // shownDate={new Date()}
          shownDate={
            new Date("March 01 2025 23:59:59 GMT-0400 (Eastern Daylight Time)")
          }
          // new Date()
          // new Date("Mar 01 2023 23:59:59 GMT-0400 (Eastern Daylight Time)")
        />
      </div>
      <div
        className={cx(styles.upcoming, {
          [styles.isUpcoming]: isUpcoming,
        })}
      >
        <h4 className={sharedStyles.h4}>
          {isUpcoming ? "Upcoming Games" : "Selected Games"}
        </h4>

        {/* <div
          className={{
            [styles.loading]: loading,
          }}
        > */}
        {gamesList?.length >= 0 && (
          <GameItemList
            games={gamesList}
            customLayout={isUpcoming ? "isUpcoming" : "isCalendar"}
          />
        )}
        {/* {gamesList?.length >= 0 &&
            gamesList.map((game) => (
              <div className={styles.game} key={game.date}>
                <GameItemSm game={game} />
              </div>
            ))} */}
        {/* {gamesList?.length === 0 && (
            <div className={styles.gameNotAvailable}>
              <h2>No games match the criteria</h2>
              <h4>There is no game matching the criteria</h4>
            </div>
          )} */}
        {/* </div> */}
        <div
          className={cx(styles.loader, {
            [styles.loading]: loading,
          })}
        >
          <Loader />
        </div>
      </div>
    </div>
  );
};
